module.exports = __webpack_public_path__ + "r-v3/img/enter_white.4859d0ff.svg";